import { render, staticRenderFns } from "./dados_input.vue?vue&type=template&id=62896e35&scoped=true&"
import script from "./dados_input.vue?vue&type=script&lang=js&"
export * from "./dados_input.vue?vue&type=script&lang=js&"
import style0 from "./dados_input.vue?vue&type=style&index=0&id=62896e35&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62896e35",
  null
  
)

export default component.exports